export const fr = {
  'common.language': 'Langue',
  'common.environment': 'Environnement',
  'is.reachable': 'est accessible',
  'is.not.reachable': 'n\'est pas accessible',
  'not.found.message': 'Cette page n\'existe pas.',
  'common.back': 'Retour',
  'an.error.occurred': 'Une erreur est survenue',
  'common.back-office': 'Back-office',
  'common.routing.game-mechanics': 'Mécaniques de jeu',
  'common.routing.dialog': 'Dialogue',
  'common.routing.image': 'Clique image',
  'common.routing.multiple-choice': 'QCM',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'QCU',
  'common.routing.users': 'Utilisateurs',
  'common.routing.files': 'Fichiers',
  'common.routing.statistics': 'Statistiques',
  'common.french': 'Français',
  'common.english': 'Anglais',
  'theme.dark': 'Mode sombre',
  'theme.light': 'Mode clair',
  'common.logout': 'Déconnexion',
  'common.users': 'Utilisateurs',
  'common.files': 'Fichiers',
  'common.results': 'résultats',
  'common.administration': 'Administration',
  'common.menu': 'Menu',
  'file-upload.success': 'Fichier téléchargé avec succès.',
  'file-upload.failed': 'Fichier non téléchargé.',
  'no.files': 'Aucun fichier.',
  'start-by-uploading-a-file-using-the-button-below': 'Commencez par télécharger un fichier en utilisant le bouton ci-dessous.',
  'common.email': 'Adresse email',
  'common.firstname': 'Prénom',
  'common.lastname': 'Nom',
  'common.role': 'Rôle',
  'common.lastConnection': 'Dernière connexion',
  'status.active': 'Activé',
  'status.pending': 'En attente',
  'common.search': 'Recherche',
  'common.add': 'Ajouter',
  'common.export': 'Exporter',
  'common.status': 'Status',
  'common.action': 'Actions',
  'common.update': 'Modifier',
  'common.delete': 'Supprimer',
  'common.impersonate': 'Usurper',
  'common.previous': 'Précédent',
  'common.next': 'Suivant',
  'good.update.user': 'La modification de l\'utilisateur a été réalisée avec succès.',
  'bad.update.user': 'La modification de l\'utilisateur a échoué.',
  'update.user': 'Modifier un utilisateur',
  'input.required.message': 'Ce champ est requis',
  'input.email.message': 'Entrez votre adresse email !',
  'common.cancel': 'Annuler',
  'good.delete.user': 'La suppression de l\'utilisateur a été réalisée avec succès.',
  'bad.delete.user': 'La suppression de l\'utilisateur a échoué.',
  'delete.user': 'Supprimer un utilisateur',
  'delete.user.first-message': 'Supprimer cet utilisateur supprimera toutes ses statistiques et accès.',
  'delete.second-message': 'Êtes-vous sûr ?',
  'good.add.user': 'L\'ajout de l\'utilisateur a été réalisé avec succès.',
  'bad.add.user': 'L\'ajout de l\'utilisateur a échoué.',
  'create.user': 'Créer un utilisateur',
  'common.create': 'Créer',
  'common.home': 'Accueil',
  'common.mechanics': 'Mécaniques',
  'quiz.result.title': 'Résultat du quiz',
  'quiz.result.questions': 'Réponses correctes',
  'quiz.result.failure': 'Échec',
  'quiz.result.success': 'Réussite',
  'quiz.restart': 'Recommencer',
  'time.left': 'Temps restant',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Bonne réponse !',
  'quiz.answer.incorrect': 'Mauvaise réponse !',
  'common.validate': 'Valider',
  'common.finish': 'Terminer',
  'messages-history': 'Historique des messages',
  'no.history.infos': 'Aucun message',
  'reset.password.success': 'Un e-mail de réinitialisation a été envoyé',
  'bad.reset.message': 'L\'email de réinitialisation n\'a pas pu être envoyé.',
  'bad.server-login.message': 'Impossible de contacter le serveur !',
  'common.loading': 'Chargement',
  'reset.password': 'Réinitialiser votre mot de passe',
  'common.submit': 'Envoyer',
  'login.return-message': 'Retour à la page de connexion',
  'input.password': 'Entrez votre mot de passe !',
  'password.not-match.message': 'Les mots de passe ne correspondent pas',
  'new.password.success': 'Votre mot de passe a été mis à jour',
  'new.password': 'Nouveau mot de passe',
  'new.password.description': 'Entrez votre nouveau mot de passe',
  'common.password': 'Mot de passe',
  'common.confirm-password': 'Confirmer le mot de passe',
  'logout.redirect.message': 'Déconnexion réussie ! Redirection dans',
  'login.microsoft': 'Connexion avec Microsoft',
  'impossible.read.token': 'Impossible de lire le token !',
  'connection.successful': 'Connexion réussie !',
  'connection.failed': 'La connexion a échoué !',
  'common.login': 'Connexion',
  'password.forgot': 'Mot de passe oublié ?',
  'have-account.message': 'Vous n\'avez pas de compte ?',
  'common.register': 'Je me crée un compte',
  'access.denied.message': 'Vous n\'avez pas les droits d\'accès à cette page.',
  'input.password-confirm': 'Confirmez votre mot de passe',
  'good.register.message': 'L\'inscription a été réalisée avec succès.',
  'bad.register.message': 'L\'inscription a échoué.',
  'finish.register': 'Création de compte',
  'password.confirm': 'Confirmez votre mot de passe',
  'good-order.message': 'L\'ordre correct est :',
  'reset.password.description': 'Entrez votre adresse e-mail pour réinitialiser votre mot de passe',
  'common.login.description': 'Entrez votre email et votre mot de passe ci-dessous pour vous connecter à votre compte',
  'finish.register.message': 'Entrez votre adresse mail, nom, prénom et mot de passe pour terminer votre inscription.',
  'good.reset.message': 'L\'email de réinitialisation a bien été envoyé.',
  'new.password-confirm': 'Confirmer le mot de passe',
  'passwords.not.match': 'Les mots de passe ne correspondent pas',
  'create.account': 'Créer un compte',
  'create.account.description': 'Entrez vos informations pour créer un compte',
  'create.account.success': 'Votre compte a été créé avec succès',
  'first.name': 'Prénom',
  'last.name': 'Nom',
  'new.password.message': 'Entrez votre adresse email et votre nouveau mot de passe',
  'common.ok': 'Valider',
  'common.game-mechanics': 'Mécaniques de jeu',
  'quiz-mechanisms.available': 'Mécaniques disponibles',
  'common.welcome': 'Bienvenue',
  'no.content': 'Aucun contenu',
  'common.confirm': 'Confirmer',
  'common.reset': 'Réinitialiser',
  'common.empty': 'Aucune donnée',
  'desc.sort': 'Cliquez pour trier par ordre décroissant',
  'asc.sort': 'Cliquez pour trier par ordre croissant',
  'cancel.sort': 'Cliquez pour annuler le tri',
  'your.informations': 'Vos informations',
  'you.are': 'Vous êtes',
  'your.email': 'Votre email',
  'token.creation.message': 'Votre session a été créée le :',
  'token.expiration.message': 'Votre session expirera le :',
  'common.hello': 'Bonjour',
  'user.management': 'Gestion des utilisateurs',
  'add.user': 'Ajouter un utilisateur',
  'bad.connection': 'Connexion impossible',
  'bad.connection.message': 'Le mot de passe et l’email saisis ne correspondent pas. Veuillez vérifier vos informations et vous connecter à nouveau.',
  'common.close': 'Fermer',
  'common.quiz-mechanics': 'Mécaniques de quiz',
  'import.user': 'Importer un utilisateur',
  'good.import.user': 'L\'import de l\'utilisateur a été réalisé avec succès.',
  'bad.import.user': 'L\'import de l\'utilisateur a échoué.',
  'download.template': 'Télécharger le modèle',
  'click.to.upload': 'Cliquez pour importer',
  'common.import': 'Importer',
  'common.settings': 'Paramètres',
  'unknow.error': 'Erreur inconnue !',
  'common.dashboard': 'Tableau de bord',
  'impersonate.user': 'Usurper un utilisateur',
  'bad.impersonate.user': 'Impossible d\'usurper l\'utilisateur.',
  'impersonate.user.first-message': 'Se faire passer pour cet utilisateur vous permettra de vous connecter en son nom.',
  'impersonate.user.second-message': 'Vous serez déconnecté.',
  'account.validate': 'Validation de compte',
  'account.validate.confirmation': 'Veuillez confirmer votre compte en cliquant sur le bouton ci-dessous',
  'valid.account.success': 'Votre compte a été validé avec succès !',
  'valid.account.failed': 'La validation de votre compte a échoué. Veuillez réessayer plus tard.',
  'resend.email.success': 'Email de validation envoyé avec succès',
  'resend.email.failed': 'Échec de l\'envoi de l\'email de validation',
  'resend.email': 'Renvoyer l\'email de validation',
  'scorm.player.title': 'Module SCORM',
  'scorm.player.loading': 'Chargement du module...',
  'scorm.player.error': 'Erreur lors du chargement du module SCORM',
  'scorm.progress.saved': 'Progression sauvegardée',
  'scorm.progress.save.error': 'Erreur lors de la sauvegarde de la progression',
  'common.statistics': 'Statistiques',
  'common.completionStatus': 'Statut de complétion',
  'common.successStatus': 'Statut de réussite',
  'common.score': 'Score',
  'common.completedAt': 'Date de complétion',
  'common.totalTime': 'Temps total',
  'status.completed': 'Complété',
  'status.incomplete': 'Incomplet',
  'status.not_attempted': 'Non commencé',
  'status.unknown': 'Inconnu',
  'status.passed': 'Réussi',
  'status.failed': 'Échoué',
  'login.sso': 'Connexion SSO',
  'sso.error': 'Erreur de connexion SSO',
}
